import * as React from 'react';

import useUrlState from '@ahooksjs/use-url-state';
import { useBoolean, useLockFn } from 'ahooks';
import { Button, Form, Input, notification, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';

import { MobileOutlinedIcon, PrimitiveForm } from 'components';
import { useLoginValue } from 'context';
import { signinWithPassword } from 'services';
import { inputRule, PATHNAME } from 'utils';

const {
  LOCAL: {
    HOME: { BASE_URL: HOME_BASE_URL },
  },
  QUERY_PARAM: {
    DEFAULT: { LOGIN_TYPE: DEFAULT_LOGIN_TYPE },
    TYPE: { BASE_URL: TYPE_BASE_URL },
  },
} = PATHNAME;

type FieldType = Required<
  Pick<ReturnType<typeof useLoginValue>, 'phoneNumber' | 'password'>
>;

const LoginDefaultForm = () => {
  const [, setUrlState] = useUrlState(
    {
      [TYPE_BASE_URL]: '',
    },
    { navigateMode: 'replace' },
  );
  const [loading, { toggle: toggleLoading }] = useBoolean();
  const [form] = Form.useForm<FieldType>();
  const navigate = useNavigate();

  const onFinish = useLockFn(async ({ phoneNumber, password }: FieldType) => {
    toggleLoading();

    signinWithPassword({ phoneNumber, password })
      .then(() => {
        navigate(HOME_BASE_URL);
        notification.success({
          message: 'با موفقیت وارد شدید.',
        });
      })
      .catch(message => {
        notification.error({ message });
      })
      .finally(() => {
        toggleLoading();
      });
  });

  return (
    <div className='basis-1/2 space-y-8'>
      <Typography.Title level={2} className='text-center text-2xl'>
        ورود با رمز ثابت
      </Typography.Title>
      <PrimitiveForm form={form} onFinish={onFinish}>
        <Form.Item<FieldType>
          label='شماره همراه'
          name='phoneNumber'
          rules={[inputRule.required, inputRule.phoneNumber]}
        >
          <Input
            placeholder='شماره همراه را وارد کنید'
            prefix={
              <MobileOutlinedIcon className='text-lg text-[--ant-color-text-placeholder]' />
            }
          />
        </Form.Item>
        <Form.Item<FieldType>
          label='رمز عبور'
          name='password'
          rules={[inputRule.required, inputRule.nonWhitespace]}
        >
          <Input.Password
            placeholder='رمز عبور را وارد کنید'
            prefix={
              <MobileOutlinedIcon className='text-lg text-[--ant-color-text-placeholder]' />
            }
          />
        </Form.Item>
        <Form.Item className='mb-4'>
          <Button block type='primary' htmlType='submit' loading={loading}>
            ورود
          </Button>
        </Form.Item>
        <Form.Item className='mb-0'>
          <Button
            block
            onClick={() => {
              setUrlState({ [TYPE_BASE_URL]: DEFAULT_LOGIN_TYPE });
            }}
          >
            ورود با رمز یک‌بار مصرف
          </Button>
        </Form.Item>
      </PrimitiveForm>
    </div>
  );
};

export { LoginDefaultForm };
